import { render } from "./cs.vue?vue&type=template&id=60fa30f5&scoped=true"
import script from "./cs.vue?vue&type=script&lang=js"
export * from "./cs.vue?vue&type=script&lang=js"

import "./cs.vue?vue&type=style&index=0&id=60fa30f5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60fa30f5"

export default script